import { render } from "./asset.vue?vue&type=template&id=215a6c48&scoped=true"
import script from "./asset.vue?vue&type=script&lang=js"
export * from "./asset.vue?vue&type=script&lang=js"

import "./asset.vue?vue&type=style&index=0&id=215a6c48&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215a6c48"]])

export default __exports__